const categoryManagement = () =>
  import("@/pages/category/categoryManagement/categoryManagement");
const contentType = () => import("@/pages/category/contentType/contentType");
const columnManagement = () =>
  import("@/pages/category/columnManagement/index.vue");
const carouselMgt = () => import("@/pages/category/carousel/index.vue");
const linkMgt = () => import("@/pages/category/link/index.vue");
const contentsMgt = () => import("@/pages/category/contents/index.vue");
const individuality = () =>
  import("@/pages/category/individuality/individuality");
const resourceMgt = () => import("@/pages/category/resource/index.vue");
const buildAndPublish = () => import("@/pages/category/buildAndPublish");

export default [
  {
    path: "/category/categoryManagement",
    name: "categoryManagement",
    component: categoryManagement,
    meta: {
      title: "栏目管理",
      noCache: true,
      affix: true,
      path: ["内容管理", "栏目管理", "栏目管理"]
    }
  },

  {
    path: "/category/contentType",
    name: "contentType",
    component: contentType,
    meta: {
      title: "内容类型",
      noCache: true,
      affix: false,
      path: ["内容管理", "栏目管理", "栏目管理", "内容类型"]
    }
  },

  {
    path: "/category/columnManagement",
    name: "columnManagement",
    component: columnManagement,
    meta: {
      title: "布局",
      noCache: false,
      affix: false,
      path: ["内容管理", "栏目管理", "栏目管理", "布局"]
    }
  },

  {
    path: "/category/carouselManagement",
    name: "carouselMgt",
    component: carouselMgt,
    meta: {
      title: "轮播图管理",
      noCache: true,
      affix: true,
      path: ["内容管理", "栏目管理", "轮播图管理"]
    }
  },

  {
    path: "/category/linkManagement",
    name: "linkMgt",
    component: linkMgt,
    meta: {
      title: "系统链接管理",
      noCache: true,
      affix: true,
      path: ["内容管理", "栏目管理", "系统链接管理"]
    }
  },

  {
    path: "/category/contentsManagement",
    name: "contentsMgt",
    component: contentsMgt,
    meta: {
      title: "内容管理",
      noCache: true,
      affix: true,
      path: ["内容管理", "栏目管理", "内容管理"]
    }
  },

  {
    path: "/category/individuality",
    name: "individuality",
    component: individuality,
    meta: {
      title: "站点设置",
      noCache: true,
      affix: true,
      path: ["内容管理", "栏目管理", "站点设置"]
    }
  },

  {
    path: "/category/resourceManagement",
    name: "resourceMgt",
    component: resourceMgt,
    meta: {
      title: "站点设置",
      noCache: true,
      affix: true,
      path: ["内容管理", "栏目管理", "资源管理"]
    }
  },
  {
    path: "/category/buildAndPublish",
    name: "buildAndPublish",
    component: buildAndPublish,
    meta: {
      title: "构建发布",
      noCache: true,
      affix: true,
      path: ["内容管理", "构建发布"]
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/categoryInfo.js